import { ChevronRight, Search } from "@mui/icons-material";
import { InputAdornment, Paper, TextField } from "@mui/material";
import {
  GridColDef,
  GridActionsCellItem,
  DataGrid,
  GridValueGetterParams,
  GridRowParams,
} from "@mui/x-data-grid";
import React, { useState } from "react";
import "./styles.scss";
import { PartnershipType } from "../../types/genericType";

type DistributionsTableProps = {
  data: Array<PartnershipType>;
  setSelectedPartnership: Function;
};

const DistributionsTable = (props: DistributionsTableProps) => {
  const { data, setSelectedPartnership } = props;
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (event: any) => {
    setSelectedPartnership(null);
    const term = event.target.value;
    setSearchTerm(term);

  };

  const filteredData = data.filter((row: any) =>
    Object.values(row).some(
      (value) =>
        typeof value === "string" && value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const columns: GridColDef[] = React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: "Select a partnership",
        hideable: false,
        minWidth: 230,
        sortable: false,
        headerClassName: "header-datagrid",
      },
      {
        field: "id",
        headerName: "",
        sortable: false,
        width: 30,
        align: "center",
        headerAlign: "center",
        headerClassName: "header-datagrid",
        type: "actions",
        getActions: (params: GridValueGetterParams) => [
          <GridActionsCellItem
            icon={<ChevronRight sx={{ fontSize: "20px" }} />}
            label="Details"
            onClick={() => {
              setSelectedPartnership(params.row);
            }}
          />,
        ],
      },
    ],
    []
  );

  return (
    <Paper elevation={3} className="distributions-table">
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        className="search-field"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearch}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      />
      {filteredData.length > 0 ? (
        <DataGrid
          rows={filteredData}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          rowSelection={false}
          className="datagrid"
          onRowClick={(params: GridRowParams) => {
            setSelectedPartnership(params.row);
          }}
        />
      ) : (
        <div className="no-results">No results found</div>
      )}
    </Paper>
  );
};

export default DistributionsTable;
